import { useEffect, useState } from 'react';
import { nextMeeting, providerOf, scheduleLine, whenText } from '../lib/meeting';
import type { Classroom } from '../lib/types';

/**
 * The class's live meeting: which service, when (in the viewer's own time),
 * and a Join button. Bright and pulsing from 10 minutes before until it ends.
 * Renders nothing if the class has no meeting link.
 */
export default function MeetingCard({ c, teacher = false }: { c: Classroom; teacher?: boolean }) {
  const [, tick] = useState(0);
  useEffect(() => {
    const id = window.setInterval(() => tick(x => x + 1), 30000);
    return () => window.clearInterval(id);
  }, []);
  if (!c.meet_url || !/^https:\/\//.test(c.meet_url)) return null;

  const p = providerOf(c.meet_url);
  const n = nextMeeting(c);
  const schedule = scheduleLine(c);
  const live = !!n?.live;

  return (
    <div className={`meeting-card${live ? ' live' : ''}`}>
      <span className="meeting-icon" aria-hidden>{p.icon}</span>
      <span className="grow">
        <strong>{live ? 'Class is on now!' : teacher ? 'Your class meeting' : 'Class meeting'}</strong>
        <span className="small">
          {p.name}{schedule ? ` · ${schedule}` : ''}
          {n && !live && <> · <span className="meeting-when">{whenText(n)}</span></>}
          {n && live && <> · <span className="meeting-when">{whenText(n)}</span></>}
        </span>
      </span>
      <a className={`button ${live ? 'primary' : ''} meeting-join`} href={c.meet_url} target="_blank" rel="noopener noreferrer">
        {live ? '▶ Join now' : 'Join class'}
      </a>
    </div>
  );
}
